export { default } from './SecurityRender';
